export default __webpack_public_path__ + "static/media/Document.6e870910.svg";